import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import LoadingScreen from "../components/LoadingScreen"
import Table from "../components/Table";
import useHttpUtility from "../utilities/useHttpUtility";

export default function PagePackageSizes() {

    const navigate = useNavigate();
    const http = useHttpUtility();

    const [data, setData] = useState(null);
    
    useEffect(() => {
        http.get("/api/PackageSizes", setData);
    }, []);

    return (
        !data
            ? <LoadingScreen isFullScreen={true} />
            :
                <div className="page page-package-sizes">
                    <h2>Package Sizes</h2>
                    <p>The first active package size with no rules or valid rules found will be used based on sort order followed by newest package size was added.  If no package size is found then a default of size of 25cm x 25cm x 25cm 10kg will be used, to override this default, create a package size with no rules and with the highest sort order.</p>
                    <Table
                        data={data}
                        mappings={
                            [
                                {
                                    header: "Name",
                                    field: "name"
                                },
                                {
                                    header: "Length",
                                    field: "length"
                                },
                                {
                                    header: "Width",
                                    field: "width"
                                },
                                {
                                    header: "Height",
                                    field: "height"
                                },
                                {
                                    header: "Weight",
                                    field: "weight"
                                },
                                {
                                    header: "Sort Order",
                                    field: "sortOrder"
                                },
                                {
                                    header: "Active",
                                    field: "active"
                                }
                            ]
                        }
                    pageSize={20}
                    onClick={(idx) => navigate(`${data[idx].id}${window.location.search}`)}
                    onClickAdd={() => navigate(`0${window.location.search}`)} />
                </div>
    );
}